// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-companies-container {
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  flex-grow: 1;
  height: calc(100dvh - 56px);
  padding-top: 40px;
}
@media (min-width: 768px) {
  .related-companies-container {
    padding-left: 5%;
  }
}
.related-companies-container .top-text {
  padding: 24px 0;
}
@media (max-width: 768px) {
  .related-companies-container .top-text {
    padding: 10px 0;
  }
}
@media (max-width: 350px) {
  .related-companies-container .top-text {
    padding: 0;
  }
}
.related-companies-container .available-companies {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  margin: 15px 0;
}
.related-companies-container .available-companies label {
  width: 100%;
  display: flex;
  justify-content: center;
}
@media (min-width: 768px) {
  .related-companies-container .available-companies {
    gap: 16px;
  }
  .related-companies-container .available-companies label {
    justify-content: initial;
  }
}
@media (max-width: 816px) {
  .related-companies-container .available-companies {
    gap: 8px;
  }
}
.related-companies-container .company__register__area {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 32px;
}
.related-companies-container .company__register__area .BaSe--checkbox div:last-child {
  width: 18px;
  height: 18px;
}
.related-companies-container .company__register__area a {
  color: #394d60;
  text-decoration: underline;
  cursor: pointer;
}
.related-companies-container .company__register__area a:hover {
  filter: brightness(2);
}
.related-companies-container .company__register__area__button {
  display: flex;
  justify-content: center;
}
.related-companies-container .company__register__area__motto {
  display: flex;
  align-items: center;
  width: 220px;
  padding: 24px 0;
}
.related-companies-container .company__register__area__motto .line {
  flex-grow: 1;
  height: 1px;
  background-color: var(--sebrae-light-gray-2);
  margin: 0 10px;
}
.related-companies-container .company__bottom__content {
  margin-top: auto;
  display: flex;
  flex-direction: column;
}
.related-companies-container .company__bottom__content .read-terms {
  display: flex;
  align-items: center;
}
.related-companies-container .company__bottom__content .read-terms .BaSe--checkbox div:last-child {
  width: 18px;
  height: 18px;
}
@media (max-width: 665px) {
  .related-companies-container .company__bottom__content .read-terms {
    align-items: baseline;
  }
}
@media (max-width: 320px) {
  .related-companies-container .company__bottom__content .read-terms {
    padding-top: 16px;
  }
}
.related-companies-container .company__bottom__content .read-terms .underlined-term {
  text-decoration: underline;
  cursor: pointer;
}
.related-companies-container .company__bottom__content .read-terms .underlined-term:hover {
  filter: brightness(2);
}
.related-companies-container .company__bottom__content .company__button {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 32px 0 16px;
}
.related-companies-container .company__bottom__content .company__button-continue {
  margin-left: auto;
}
@media (max-width: 350px) {
  .related-companies-container .company__bottom__content .company__button {
    padding-top: 16px;
  }
}
@media (min-width: 768px) {
  .related-companies-container .company__bottom__content .company__button {
    flex-direction: row;
    padding: 32px 32px 0 0;
  }
  .related-companies-container .company__bottom__content .company__button-continue {
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,2BAAA;EAEA,iBAAA;AAAF;AAEE;EATF;IAUI,gBAAA;EACF;AACF;AACE;EACE,eAAA;AACJ;AACI;EAHF;IAII,eAAA;EAEJ;AACF;AAAI;EAPF;IAQI,UAAA;EAGJ;AACF;AAAE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAEJ;AAAI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAEN;AACI;EAZF;IAaI,SAAA;EAEJ;EAAI;IACE,wBAAA;EAEN;AACF;AACI;EApBF;IAqBI,QAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AACJ;AAGQ;EACE,WAAA;EACA,YAAA;AADV;AAMI;EACE,cAAA;EACA,0BAAA;EACA,eAAA;AAJN;AAMM;EACE,qBAAA;AAJR;AAQI;EACE,aAAA;EACA,uBAAA;AANN;AASI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAPN;AASM;EACE,YAAA;EACA,WAAA;EACA,4CAAA;EACA,cAAA;AAPR;AAYE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AAVJ;AAYI;EACE,aAAA;EACA,mBAAA;AAVN;AAcU;EACE,WAAA;EACA,YAAA;AAZZ;AAiBM;EAbF;IAcI,qBAAA;EAdN;AACF;AAgBM;EAjBF;IAkBI,iBAAA;EAbN;AACF;AAeM;EACE,0BAAA;EACA,eAAA;AAbR;AAeQ;EACE,qBAAA;AAbV;AAkBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAhBN;AAkBM;EACE,iBAAA;AAhBR;AAmBM;EAVF;IAWI,iBAAA;EAhBN;AACF;AAkBM;EAdF;IAeI,mBAAA;IACA,sBAAA;EAfN;EAiBM;IACE,cAAA;EAfR;AACF","sourcesContent":[".related-companies-container {\n  display: flex;\n  overflow-y: auto;\n  flex-direction: column;\n  flex-grow: 1;\n  height: calc(100dvh - 56px);\n  //padding-top: 5%;\n  padding-top: 40px;\n\n  @media (min-width: 768px) {\n    padding-left: 5%;\n  }\n\n  .top-text {\n    padding: 24px 0;\n\n    @media (max-width: 768px) {\n      padding: 10px 0;\n    }\n\n    @media (max-width: 350px) {\n      padding: 0;\n    }\n  }\n\n  .available-companies {\n    display: flex;\n    flex-wrap: wrap;\n    overflow-y: auto;\n    margin: 15px 0;\n\n    label {\n      width: 100%;\n      display: flex;\n      justify-content: center;\n    }\n\n    @media (min-width: 768px) {\n      gap: 16px;\n\n      label {\n        justify-content: initial;\n      }\n    }\n\n    @media (max-width: 816px) {\n      gap: 8px;\n    }\n  }\n\n  .company__register__area {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding-top: 32px;\n\n    .BaSe--checkbox {\n      div {\n        &:last-child {\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n\n    a {\n      color: #394d60;\n      text-decoration: underline;\n      cursor: pointer;\n\n      &:hover {\n        filter: brightness(2);\n      }\n    }\n\n    &__button {\n      display: flex;\n      justify-content: center;\n    }\n\n    &__motto {\n      display: flex;\n      align-items: center;\n      width: 220px;\n      padding: 24px 0;\n\n      .line {\n        flex-grow: 1;\n        height: 1px;\n        background-color: var(--sebrae-light-gray-2);\n        margin: 0 10px;\n      }\n    }\n  }\n\n  .company__bottom__content {\n    margin-top: auto;\n    display: flex;\n    flex-direction: column;\n\n    .read-terms {\n      display: flex;\n      align-items: center;\n\n      .BaSe--checkbox {\n        div {\n          &:last-child {\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n\n      @media (max-width: 665px) {\n        align-items: baseline;\n      }\n\n      @media (max-width: 320px) {\n        padding-top: 16px;\n      }\n\n      .underlined-term {\n        text-decoration: underline;\n        cursor: pointer;\n\n        &:hover {\n          filter: brightness(2);\n        }\n      }\n    }\n\n    .company__button {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      padding: 32px 0 16px;\n\n      &-continue {\n        margin-left: auto;\n      }\n\n      @media (max-width: 350px) {\n        padding-top: 16px;\n      }\n\n      @media (min-width: 768px) {\n        flex-direction: row;\n        padding: 32px 32px 0 0;\n\n        &-continue {\n          margin-left: 0;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
